package co.maytes.standupbot.dashboard.features.settings

import co.maytes.standupbot.dashboard.lib.api.ApiError
import kotlinx.datetime.LocalDate

object WorkspaceExportCopy {
    const val TITLE = "Export workspace data"
    const val DESCRIPTION =
        "Owners can download a ZIP with the workspace's members, standups, runs, prompt archive, audit log and " +
            "settings as JSON. Credentials and tokens are never included. Limited to 2 exports per hour."
    const val BUTTON = "Download export"
    const val BUTTON_BUSY = "Preparing export…"
    const val DONE = "Workspace data exported"
    const val ZIP_MIME_TYPE = "application/zip"
    private const val RATE_LIMITED_STATUS = 429

    fun fileName(date: LocalDate): String = "standupbot-export-$date.zip"

    fun failureMessage(error: ApiError): String =
        if (error is ApiError.Http && error.status == RATE_LIMITED_STATUS) {
            "You can export workspace data twice an hour. Try again in a little while."
        } else {
            "Export failed: ${error.displayMessage}"
        }
}
